import React from 'react'

//styles
import "./Skeleton.css"
import { Skeleton } from 'antd'

interface Props{
    loading?: boolean
    children?: React.ReactNode
}

const SkeletonProduct = ({loading, children}:Props) => {
  return (
    <>
    
    {loading? 
        [1,2,3, 4, 5].map((x, index) => (
            <div key={"Skeleton"+index} className='SkeletonCartComponent'>
            <Skeleton.Image active={true} style={{width:"100%", height:"150px"}} />
            <div className='SkeletonCartTitle'>
            <Skeleton.Button active={true} size={"default"} style={{width:"40%"}}/>
            <Skeleton.Button active={true} size={"default"} style={{width:"40%"}}/>
        
            </div>
            <Skeleton.Input active={true} size={"default"} style={{width:"100%"}} />
            </div>
        ))
    
    

    
    : children
    }

    </>
  )
}

export default SkeletonProduct